import React, { useRef, useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import CardSection from "../../../../components/ui/card/CardSection";
import FormCreator from "../../../../components/forms/FormCreator";
import { generalInfoFormConfig } from "./generalInfo.formfields.config";
import Buttons from "../../../../components/ui/button/Buttons";
import ClientPlansList from "../clientPlansList/ClientPlansList";
import CenterModal from "../../../../components/ui/centerModal/CenterModal";
import AddEditClientPlans from "../addEditClientPlans/AddEditClientPlans";
import ClientValuationsList from "../clientValuationsList/ClientValuationsList";
import AddEditClientValuation from "../addEditClientValuation/AddEditClientValuation";
import { decryptUrlData, encryptUrlData } from "../../../../services/CryptoService";
import { useGetClientByClientIdMutation, useUpdateClientMutation } from "../../../../app/services/ClientAPI";
import "../../Clients.scss";
import ToastService from "../../../../services/toastService/ToastService";
import PropTypes from "prop-types";

const ClientDetails = (props) => {
  const navigate = useNavigate();
  const plansGridRef = useRef();
  const valuationsGridRef = useRef();

  const [isEdit, setIsEdit] = useState(false);
  const generalInfoRef = useRef(null);
  const [selectRow, setSelectrow] = useState("")
  const [selectPlan, setSelectPlan] = useState()
  const [editClientPlanData, setEditClientPlanData] = useState(null);
  const [clientForm, setClientForm] = useState(generalInfoFormConfig);

  const [modalOpen, setModalOpen] = React.useState(false);
  const closeModal = () => setModalOpen(false);

  const { id } = useParams();

  const clientData = id ? decryptUrlData(id) : null;
  const clientID = clientData.clientID;

  const [isClientPlanModelOpen, setIsClientPlanModelOpen] = useState(false);
  const [isClientPlanValuationModelOpen, setIsClientValuationModelOpen] = useState(false);
  const [selectedValId, setSelectedValId] = useState()

  const [getClientByClientId, {
    isLoading: isGetClientLoading,
    isFetching: isGetClientFetching,
    isSuccess: isGetClientSuccess,
    data: clientByClientIdData
  }] = useGetClientByClientIdMutation();

  const [updateClient, {
    isLoading: isClientUpdating,
    isSuccess: isClientUpdated,
    data: clientUpdatedData,
  }] = useUpdateClientMutation();

  useEffect(() => {
    if (clientID) {
      getClientByClientId(clientID);
    }
  }, []);

  const formatEIN = (ein) => {
    if (!ein) return "";
    const einString = ein.toString();
    const cleaned = einString.replace(/\D/g, '');
    if (cleaned.length !== 9) return einString;
    return `${cleaned.slice(0, 2)}-${cleaned.slice(2)}`;
  };


  const handleUpdateClick = () => {
    const formData = generalInfoRef.current.getFormData();

    if (formData) {
      const formattedEIN = formatEIN(formData.ein);

      const req = {
        clientID: clientID,
        clientName: formData.clientName,
        EIN: formattedEIN,
        status: formData.status ? 1 : 0
      };
      updateClient(req);
    }
  };


  useEffect(() => {
    if (isClientUpdated && clientUpdatedData) {
      if (clientUpdatedData?.errorMessage?.includes('exist')) {
        ToastService.warning(clientUpdatedData.errorMessage);
      } else {
        ToastService.success(clientUpdatedData.errorMessage);
        props.onSuccess?.();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isClientUpdated, clientUpdatedData]);

  useEffect(() => {
    if (!isGetClientFetching && isGetClientSuccess && clientByClientIdData) {
      let formData = { ...generalInfoFormConfig };
      formData.initialState = {
        ...generalInfoFormConfig.initialState,
        clientName: clientByClientIdData.clientName,
        ein: clientByClientIdData.ein,
        status: clientByClientIdData.status === 1 ? true : false
      }
      setClientForm(formData);
    }
  }, [isGetClientFetching, isGetClientSuccess, clientByClientIdData]);

  const handleBackClick = () => { navigate("/clients"); };

  const handleAddPlanClick = () => {
    setIsClientPlanModelOpen(true);
    setEditClientPlanData(null);
    setIsEdit(false);
  };
  const handleAddPValiuationClick = () => {
    setIsClientValuationModelOpen(true);
    setIsEdit(false);
  };

  const handleCloseModel = () => {
    setIsClientPlanModelOpen(false);
    setIsClientValuationModelOpen(false);
    setEditClientPlanData(null);
    setIsEdit(false);
  };

  const handleEditClick = (data) => {
    setIsClientPlanModelOpen(true);
    setEditClientPlanData(data);
    setIsEdit(true);
  };

  const handleViewValuationClick = (data) => {
    const req = {
      valID: data.valID,
      planID: data.planID,
      clientData: clientID,
      clientName: clientByClientIdData?.clientName
    }
    setSelectedValId(data.valID)
    navigate(`/clientValuationDetails/${encryptUrlData(req)}`);
  };

  const handleSuccess = () => {
    handleCloseModel();
    if (plansGridRef.current) {
      plansGridRef.current.refreshGrid();
    }
  };

  if (valuationsGridRef.current) {
    valuationsGridRef.current.refreshGrid();
  }

  useEffect(() => {
    if (clientData) {
      let formData = { ...generalInfoFormConfig };
      formData.initialState = {
        ...generalInfoFormConfig.initialState,
        clientName: clientData.clientName,
        eIN: clientData.ein,
        active: clientData.status === 1
      }
      setClientForm(formData)
    }
  }, []);

  return (
    <>
      <div className="client-detail">
        <div className="row">
          <div className="col-xl-6 col-lg-6 col-12">
            <CardSection
              cardTitle={`General information : ${clientByClientIdData?.clientName}`}
              rightButton={true}
              buttonClassName={"blue-btn"}
              titleButtonClick={handleBackClick}
              buttonText={"Back to List"}
              searchInput={false}
              isButtonVisible={true}
              isButtonLoading={""}
              isIcon={true}
              iconClass="ic:round-arrow-back"
            >
              <div className="row">
                <FormCreator
                  ref={generalInfoRef}
                  config={clientForm}
                />
                <div className="col-12">
                  <div className="form-button-group mt-0">
                    <Buttons
                      buttonText="Update"
                      buttonTypeClassName="btn blue-btn w-full"
                      onClick={handleUpdateClick}
                      isLoading={false}
                    />
                  </div>
                </div>
              </div>
            </CardSection>
          </div>
          <div className="col-xl-6 col-lg-6 col-12 plan-list-sec">
            <CardSection
              cardTitle={"Plans"}
              rightButton={true}
              buttonClassName={"blue-btn"}
              titleButtonClick={handleAddPlanClick}
              buttonText={"ADD"}
              searchInput={false}
              isButtonVisible={true}
              isButtonLoading={""}
              isIcon={true}
              iconClass="uil:plus"
            >
              <div className="client-plan-list-body-scroll">
                <ClientPlansList
                  ref={plansGridRef}
                  onEdit={handleEditClick}
                  clientID={clientData.clientID}
                  setSelectrow={setSelectrow}
                  setSelectPlan={setSelectPlan}
                />
              </div>
            </CardSection>
          </div>
          <div className="col-xl-12 col-lg-12 col-12 valuation-list-sec">
            <CardSection
              cardTitle={`Valuations of Plan : ${selectPlan}`}
              rightButton={true}
              buttonClassName={"blue-btn"}
              titleButtonClick={handleAddPValiuationClick}
              buttonText={"ADD"}
              searchInput={false}
              isButtonVisible={true}
              isButtonLoading={""}
              isIcon={true}
              iconClass="uil:plus"
              isDisable={typeof (selectPlan) != "undefined" ? false : true}
            >
              <div className="valuation-card-body-scroll">
                <ClientValuationsList
                  ref={valuationsGridRef}
                  onView={handleViewValuationClick}
                  selectRow={selectRow}
                  clientID={clientData.clientID}
                  selectedValId={selectedValId}
                />
              </div>
            </CardSection>
          </div>
        </div>
      </div>
      <CenterModal
        modalTitle={isEdit ? `Update Plans` : `Add Plans`}
        modalSize={"w-35"}
        isOpen={isClientPlanModelOpen}
        onClose={handleCloseModel}
        transition={"grow"}
      >
        <AddEditClientPlans
          isEdit={isEdit}
          isOpen={isClientPlanModelOpen}
          initData={editClientPlanData}
          onClose={handleCloseModel}
          clientName={clientByClientIdData?.clientName}
          clientID={clientData.clientID}
          onSuccess={handleSuccess}
        />
      </CenterModal>
      <CenterModal
        modalTitle={isEdit ? `Update Valuation` : `Add Valuation`}
        modalSize={"w-50"}
        isOpen={isClientPlanValuationModelOpen}
        onClose={handleCloseModel}
        transition={"grow"}
        className={"add-valuation-modal"}
      >
        <AddEditClientValuation
          isEdit={isEdit}
          isOpen={isClientPlanValuationModelOpen}
          initData={editClientPlanData}
          onClose={handleCloseModel}
          onSuccess={handleSuccess}
          clientName={clientByClientIdData?.clientName}
          selectRow={selectRow}
          selectPlan={selectPlan}
        />
      </CenterModal>
    </>
  );
};

ClientDetails.propTypes = {
  onSuccess: PropTypes.func
};

export default ClientDetails;
